export default __webpack_public_path__ + "static/Moderat-Bold-43589ddd886fc50997993561913d7fc3.woff2";